/** @format */

// import { createApp } from "vue";
import * as Vue from "vue";
import App from "./App.vue";
import axios from "./plugins/axios";
import VueAxios from "vue-axios";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { createI18n } from "vue-i18n";
import en from "./locales/en";
import ja from "./locales/ja";
import constant from "./config/constant";
import Loading from "vue3-loading-overlay";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "./assets/styles/style.css"; // ✅ import your CSS variables
import { vue3Debounce } from "vue-debounce";
// import { QuillEditor } from "vue3-quill";
// import "quill/dist/quill.snow.css";
loadFonts();

if (!localStorage.getItem("lang") || localStorage.getItem("lang") == "null") {
  const browserLanguage = navigator.language;
  if (browserLanguage == "ja" || browserLanguage == "ja-JP") {
    localStorage.setItem("lang", "ja");
  } else {
    localStorage.setItem("lang", "en");
  }
}

const i18n = createI18n({
  locale: localStorage.getItem("lang") || "en",
  legacy: false,
  messages: {
    en: en,
    ja: ja,
  },
});

// const ignoreMessages = ["ResizeObserver loop completed"];
// const originalWarn = console.error;
// console.error = (...args) => {
//   if (args[0] && ignoreMessages.some((msg) => args[0].includes(msg))) return;
//   originalWarn(...args);
// };

const app = Vue.createApp(App).use(router).use(store).use(vuetify).use(i18n);
app.config.globalProperties.$constant = constant;
app.component("v3-loading", Loading);
// app.component("vue3-quill", QuillEditor);
app.use(VueAxios, axios);
app.provide("axios", app.config.globalProperties.axios); // provide 'axios'
app.directive("debounce", vue3Debounce({ lock: true }));
app.mount("#app");
window.app = app;
